"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const osmHelpers_1 = require("./helpers/osmHelpers");
const leaflet_1 = __importDefault(require("leaflet"));
class AddMarkers {
    constructor(map, markers, container) {
        this.markers = markers;
        this.container = container;
        this.map = map;
        this.locations = JSON.parse(this.container.getAttribute('data-js-map-pin-data') || '[]');
        this.markerElementObjects = [];
        this.addMarkersToMap();
    }
    addMarkersToMap() {
        var _a, _b;
        const locations = (_a = (0, osmHelpers_1.allLocations)(this.container)) !== null && _a !== void 0 ? _a : [];
        locations.forEach((location) => {
            var _a, _b;
            if ((location === null || location === void 0 ? void 0 : location.lat) && (location === null || location === void 0 ? void 0 : location.lng)) {
                let customIcon = undefined;
                if (location === null || location === void 0 ? void 0 : location.icon) {
                    customIcon = location.icon;
                }
                let marker = leaflet_1.default.marker([location.lat, location.lng], {
                    icon: this.createMarker(customIcon),
                });
                if (location.tooltip) {
                    marker.bindPopup(this.createTooltipFromTemplate(location.tooltip), { maxWidth: 300 });
                }
                marker.on('click', (e) => {
                    var _a, _b, _c, _d, _e, _f;
                    let latlng = e.latlng
                        ? e.latlng
                        : ((_a = e.sourceTarget) === null || _a === void 0 ? void 0 : _a._latlng)
                            ? (_b = e.sourceTarget) === null || _b === void 0 ? void 0 : _b._latlng
                            : false;
                    let zoomLevel = (_d = (_c = this.map) === null || _c === void 0 ? void 0 : _c.getZoom()) !== null && _d !== void 0 ? _d : 16;
                    if (latlng) {
                        if (zoomLevel >= 16) {
                            (_e = this.map) === null || _e === void 0 ? void 0 : _e.setView(latlng);
                        }
                        else {
                            (_f = this.map) === null || _f === void 0 ? void 0 : _f.setView(latlng, 16);
                        }
                    }
                    (0, osmHelpers_1.pushCoordinatesToBrowserHistory)({ lat: location.lat, lng: location.lng });
                });
                (_a = this.markers) === null || _a === void 0 ? void 0 : _a.addLayer(marker);
                if (location.element) {
                    (_b = this.markerElementObjects) === null || _b === void 0 ? void 0 : _b.push({ marker: marker, element: location.element });
                }
            }
        });
        (_b = this.markers) === null || _b === void 0 ? void 0 : _b.addTo(this.map);
    }
    createMarker(customIcon) {
        var _a;
        let template = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector('.c-openstreetmap__pin-icon');
        let html = template === null || template === void 0 ? void 0 : template.innerHTML;
        let icon = (customIcon === null || customIcon === void 0 ? void 0 : customIcon.icon) ? customIcon.icon : 'location_on';
        let color = (customIcon === null || customIcon === void 0 ? void 0 : customIcon.backgroundColor)
            ? customIcon.backgroundColor
            : this.getPrimaryColor();
        if (!html)
            return;
        html = html
            .replace('{icon-name}', icon)
            .replaceAll('{ICON_NAME}', icon)
            .replace('{ICON_BACKGROUND_COLOR}', color);
        let marker = leaflet_1.default.divIcon({
            className: 'c-openstreetmap__icon',
            html: html,
        });
        return marker;
    }
    createTooltipFromTemplate(tooltip) {
        var _a, _b, _c, _d, _e, _f;
        let template = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector('.c-openstreetmap__pin-tooltip');
        let clone = template === null || template === void 0 ? void 0 : template.cloneNode(true);
        if (!((_b = tooltip.image) === null || _b === void 0 ? void 0 : _b.src)) {
            const figure = clone.content.querySelector('figure');
            if (figure) {
                figure.remove();
            }
        }
        if (!tooltip.url) {
            let link = clone.content.querySelector('.c-openstreetmap__tooltip-link');
            let title = clone.content.querySelector('.c-openstreetmap__tooltip-title');
            const parent = link === null || link === void 0 ? void 0 : link.parentNode;
            if (parent && title && link) {
                parent.insertBefore(title, link);
                link.remove();
            }
        }
        let html = clone.innerHTML;
        html = html
            .replace('{TOOLTIP_HEADING}', tooltip.title ? tooltip.title : '')
            .replace('{TOOLTIP_DIRECTIONS_URL}', ((_c = tooltip.directions) === null || _c === void 0 ? void 0 : _c.url) ? tooltip.directions.url : '')
            .replace('{TOOLTIP_DIRECTIONS_LABEL}', ((_d = tooltip.directions) === null || _d === void 0 ? void 0 : _d.label) ? tooltip.directions.label : '')
            .replace('{TOOLTIP_EXCERPT}', tooltip.excerpt ? tooltip.excerpt : '')
            .replace('{TOOLTIP_IMAGE_SRC}', ((_e = tooltip.image) === null || _e === void 0 ? void 0 : _e.src) ? tooltip.image.src : '')
            .replace('{TOOLTIP_IMAGE_ALT}', ((_f = tooltip.image) === null || _f === void 0 ? void 0 : _f.alt) ? tooltip.image.alt : '')
            .replace('{TOOLTIP_LINK}', tooltip.url ? tooltip.url : '');
        return html;
    }
    getMarkerElementObjects() {
        return this.markerElementObjects;
    }
    getPrimaryColor() {
        let color = getComputedStyle(document.documentElement).getPropertyValue('--color-primary');
        return color ? color : '#ae0b05';
    }
}
exports.default = AddMarkers;
